(function (angular, app) {
   "use strict";

    angular.module(app.modules.common.name)
        .constant(app.modules.common.constants.tourslideslist,
        
         [
          {title : "Connect with your golf group" , description : "Connect and organize the people you play golf with.  Then, compete and share your experience with our comminity of golfers.", image : "images/tour/1.jpg"} 
          , {title : "Track golf outings with live leaderboards" , description : "Professional style leaderboards for each event allow you to view your competition during the event and share with your friends.", image : "images/tour/2.jpg"} 
          , {title: "Wagers, statistics & handicaps" , description : "Track your teebox wagers plus every statistic that you can think of - and score your outings with a net handicap.", image : "images/tour/3.jpg"} 
          , {title : "Unlimited groups, outings, rounds and players" , description : "Organize outings for your buddies, your league, or your commuinity with ease.", image : "images/tour/4.jpg"} 
         ]        
        );
}(angular, app));
